var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashCapFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5L16.7998 5C17.9199 5 18.4799 5 18.9078 5.21799C19.2841 5.40973 19.59 5.7157 19.7818 6.09202C19.9998 6.51984 19.9998 7.0799 19.9998 8.2V10M2 19L16.7998 19C17.9199 19 18.4799 19 18.9078 18.782C19.2841 18.5903 19.59 18.2843 19.7818 17.908C19.9998 17.4802 19.9998 16.9201 19.9998 15.8V14M2 12H18M19.9998 14H20.4002C20.9603 14 21.2403 14 21.4542 13.891C21.6424 13.7951 21.7954 13.6422 21.8913 13.454C22.0002 13.2401 22.0002 12.9601 22.0002 12.4V11.6C22.0002 11.0399 22.0002 10.7599 21.8913 10.546C21.7954 10.3578 21.6424 10.2049 21.4542 10.109C21.2403 10 20.9603 10 20.4002 10H19.9998M19.9998 14H19.6002C19.0402 14 18.7602 14 18.5463 13.891C18.3581 13.7951 18.2051 13.6422 18.1092 13.454C18.0002 13.2401 18.0002 12.9601 18.0002 12.4V11.6C18.0002 11.0399 18.0002 10.7599 18.1092 10.546C18.2051 10.3578 18.3581 10.2049 18.5463 10.109C18.7602 10 19.0402 10 19.6002 10H19.9998",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashCapFlat);
export default __webpack_public_path__ + "static/media/dash-cap-flat.0ed0d745c97e08ccd796fa59d8796cc7.svg";
export { ForwardRef as ReactComponent };